<template>
  <v-slide-y-transition hide-on-leave>
    <div class="d-flex align-center">
      <p class="subtitle-2 grey--text text--darken-2 pa-0 ml-5 my-0 mr-0">
        {{
          $t('routines.items_selectedWithCount', {
            count: this.selectedFindingsLength,
          })
        }}
      </p>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <Button
            v-if="permissions.edit"
            icon="mdi-account-plus"
            class="ml-8"
            color="blueGrey"
            v-on="on"
            @click="$emit('bulkAddAssignees')"
          />
        </template>
        {{ $t('routines.assign') }}
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <Button
            v-if="permissions.edit"
            icon="mdi-calendar"
            class="ml-8"
            color="blueGrey"
            v-on="on"
            @click="$emit('bulkDueDate')"
          />
        </template>
        {{ $t('routines.edit_due_date') }}
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <Button
            v-if="permissions.delete"
            icon="mdi-trash-can-outline"
            class="ml-8"
            color="blueGrey"
            v-on="on"
            @click="$emit('bulkDelete')"
          />
        </template>
        {{ $t('common.button.delete') }}
      </v-tooltip>
    </div>
  </v-slide-y-transition>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'BulkActions',

  components: {
    Button,
  },

  props: {
    permissions: {
      type: Object,
      required: true,
    },
    selectedFindingsLength: {
      type: Number,
      required: true,
    },
  },
}
</script>
